import { render } from "./NavMobile.vue?vue&type=template&id=534501f9&scoped=true"
import script from "./NavMobile.vue?vue&type=script&lang=ts"
export * from "./NavMobile.vue?vue&type=script&lang=ts"

import "./NavMobile.vue?vue&type=style&index=0&id=534501f9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-534501f9"

export default script